import App from './svelte/App.svelte'

const app = new App({
  target: document.querySelector('[data-app]')
})

export default app
